import React from 'react';

import { useListTimeFormatter } from '../hooks';

import {
  ChannelUnreadBadge,
  ChannelTime,
  ChannelMeta,
} from '../../StyledComponents';
import HighlightText from 'components/mui/HighlightText';
import Avatar from 'components/mui/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';

const PrivateChannel = ({ data, thread, unread, searchText }) => {
  const { username, picture } = data;
  const time = useListTimeFormatter(thread?.createdAt);
  const threadMessage = thread ? thread.message : '';
  const threadTime = thread ? time : '';

  return (
    <>
      <ListItemAvatar>
        <Avatar src={picture} alt={picture} />
      </ListItemAvatar>
      <ListItemText
        sx={{ my: 0, overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}
        slotProps={{ primary: { fontSize: 14 } }}
        secondary={threadMessage}
      >
        <HighlightText value={username} searchTerm={searchText} />
      </ListItemText>
      {thread && (
        <ChannelMeta>
          {threadTime && <ChannelTime variant="caption">{threadTime}</ChannelTime>}
          {unread > 0 && <ChannelUnreadBadge color="primary" badgeContent={unread} />}
        </ChannelMeta>
      )}
    </>
  );
};

export default PrivateChannel;
